import _ from 'lodash';
import AddressProxy from '@/proxies/Contact/AddressProxy';
import { prepareValidationMessages } from '@/utils';

export default {
  data() {
    return {
      currentEditableAddress: {},
      errorsAddressDialog: {},
      isShowAddressDialog: false,
      isLoadingAddressDialog: false,
    };
  },
  computed: {
    addressDialogActionLabel() {
      if (this.isShowAddressDialog) {
        return (this.currentEditableAddress.uuid) ?
          this.lang(this.$store, 'sap/listings.global.edit.save') :
          this.lang(this.$store, 'sap/listings.global.edit.create');
      }
      return '';
    },
  },
  methods: {
    onCloseAddressDialog() {
      this.isShowAddressDialog = false;
    },
    getContact() {
      return this.currentEditableItem;
    },
    onActionAddressDialog({ item, address }) {
      if (_.isObject(item) && _.isObject(address)) {
        const updatedData = address;
        this.isLoadingAddressDialog = true;
        let client = new AddressProxy();
        if (this.currentEditableAddress.uuid) {
          client = client.update(this.currentEditableAddress.uuid, updatedData);
        } else {
          updatedData.contact_uuid = item.uuid;
          client = client.create(updatedData);
        }

        client.then(response => {
          this.currentEditableAddress = response.data.data.address;
          if (this.getContact().addresses) {
            this.getContact()
              .addresses
              .forEach((contactAddress, index) => {
                if (contactAddress.uuid === this.currentEditableAddress.uuid) {
                  this.getContact().addresses[index] = this.currentEditableAddress;
                }
              });
          }
          this.$store.dispatch('page/updateCurrentPageContent');
          this.isShowAddressDialog = false;
        })
          .catch(error => {
            console.error(error);
            if (error && error.data && error.data.data) {
              this.errorsAddressDialog = prepareValidationMessages(error.data.data);
            }
          })
          .finally(() => {
            this.isLoadingAddressDialog = false;
          });
      }
    },
  },
};
